import { Account } from '../../types'

export interface ClientStatus {
  isLoggedIn: boolean
  accounts: Account[] // 客户端可能登录了多个账号
}

export interface WebStatus {
  isLoggedIn: boolean
  currentUser?: Account
}

// _cl 参数解析出来的结构
export interface ClientUrlParam {
  t: number // timestamp
  i: number // userid
  u: string // user agent
}

export interface FastLoginOptions {
  // 外部指定的账号ID (流程图节点 E)，现在主要由 URL 参数 _cl 解析而来
  // 但保留手动传入的能力以便扩展
  specifiedAccountId?: number

  // 模拟/注入 URL 参数，方便测试
  urlParams?: Record<string, string>

  // _cl 参数的时间戳有效时长 (秒), 默认 30 分钟 (30 * 60)
  // 设置为 0 或 负数 则不校验时间戳
  timestampValidityDuration?: number

  // 快捷登录成功回调
  onSuccess?: (data: any) => void
  // 登录失败回调
  onError?: (error: Error) => void

  // --- 移动端配置 ---
  // 产品品牌，用于构建唤起链接参数 (e.g. 'sun', 'pgy')
  brand?: string
  // APP 下载地址或落地页，用于未安装 APP 时的兜底跳转
  downloadUrl?: string
}

// 对应流程图的终端节点
export enum LoginStrategy {
  NORMAL_LOGIN = 'NORMAL_LOGIN', // D: 普通登录方式
  MAINTAIN_WEB_LOGIN = 'MAINTAIN_WEB_LOGIN', // J: 维持Web原有登录状态
  SHOW_SPECIFIED_LOGIN = 'SHOW_SPECIFIED_LOGIN', // I: 展示指定账号快捷登录页面
  SHOW_CONFLICT_LOGIN = 'SHOW_CONFLICT_LOGIN', // K: 快捷登录页面展示当前Web登录账号和客户端指定账号
  SHOW_ACCOUNT_SELECTION = 'SHOW_ACCOUNT_SELECTION', // L: 展示多个端账号提供选择
  SHOW_SINGLE_FAST_LOGIN = 'SHOW_SINGLE_FAST_LOGIN', // M: 展示单个端账号
  EXPIRED_PARAMS_LOGIN = 'EXPIRED_PARAMS_LOGIN', // 新增: 参数过期，回退到普通/快捷登录
}

export interface DecisionResult {
  strategy: LoginStrategy
  data?: {
    webAccount?: Account
    clientAccount?: Account // 用于 I, M, K
    clientAccounts?: Account[] // 用于 L
    specifiedParam?: ClientUrlParam // 解析出的 _cl 参数
    errorReason?: string // 错误原因，如 "expired_timestamp"
  }
}
